// Nouveau fichier: src/components/ConfirmationModal.js
import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText = 'Confirmer',
  cancelText = 'Annuler',
  type = 'danger', // "danger", "warning", "info"
  details = null, // Informations supplémentaires à afficher
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  const typeIcons = {
    danger: '🗑️',
    warning: '⚠️',
    info: 'ℹ️',
  };

  return (
    <div className="confirmation-overlay" onClick={handleBackdropClick}>
      <div className="confirmation-modal">
        <div className={`confirmation-header ${type}`}>
          <span className="confirmation-icon">{typeIcons[type]}</span>
          <h3 className="confirmation-title">{title}</h3>
        </div>

        <div className="confirmation-body">
          <p className="confirmation-message">{message}</p>
          {details && <div className="confirmation-details">{details}</div>}
        </div>

        <div className="confirmation-actions">
          <button className="confirmation-button cancel" onClick={onCancel}>
            {cancelText}
          </button>
          <button
            className={`confirmation-button confirm ${type}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
